// test1293
(1293 && 0);
